module.exports = __webpack_public_path__ + "media/appstore.c706c53e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/app-website/assets/appstore.svg
// module id = ./src/templates/app-website/assets/appstore.svg
// module chunks = 0